<template src="./CoreAccountStructureTable.html">
</template>

<script>
export default {
    name: "account-structure-table-component",
    props: {
        name: {
            type: String
        },
        structureDisplay: {
            type: Array,
            default: []
        }
    },
    data() {
         return {
           agencybranchlabel: {
             type: String,
             default: this.$t("Agency") + ' ' + this.$t("Branch")
           }
         }
    },
    //mounted() {
    //},
    // methods: {
    // }
};
</script>
